export function hexToRgba(hex: string) {
  let hexColor = hex;
  if (!/^#[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?([0-9A-Fa-f]{2})?$/.test(hexColor)) {
    return null;
  }

  if (hexColor.length === 4) {
    hexColor = '#' + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2] + hexColor[3] + hexColor[3];
  }

  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  let a = 1;

  if (hexColor.length === 9) {
    a = parseInt(hexColor.slice(7, 9), 16) / 255;
    a = Math.round(a * 100) / 100;
  }

  return { r, g, b, a };
}
